import {BenjiKIVOverlayScatterReSpinResultRunner} from "./BenjiKIVOverlayScatterReSpinResultRunner";
import {SimplePresentationRunnerController} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";

/**
 * Created by Jerker Nord on 2022-12-21.
 */

export class BenjiKIVOverlayScatterBoostedReSpinResultRunner extends BenjiKIVOverlayScatterReSpinResultRunner {

    constructor() {
        super();
    }

    public shouldRun():boolean {
        if(BenjiKIV.xBetView.boosted02Enabled == true && BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN
            && (BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL || BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN
                || BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)) {
            this._serverResponse = true;
            return true;
        }
        return false;
    }

    public start(controller:SimplePresentationRunnerController):void {
        super.start(controller);
    }
}